export default __webpack_public_path__ + "static/media/collogo1.9ed88aa7.png";